import AuthoriseExpensesForm from "@/components/Forms/AuthoriseExpensesForm";

const AuthoriseExpensesDetail = () => {
    return (
        <AuthoriseExpensesForm />
    )
}

export default AuthoriseExpensesDetail;